<script lang="ts">
    import { onMount } from "svelte"
    import { getDBEntry } from "../../../api"
    import { navigationCache, location, categories } from "../../store"
    import DesktopHeader from "./Desktop.svelte"
    import {
        getCategories,
        mapBigcommerceCategoriesToNavigation,
    } from "../../functions/CommerceAPIs/bigCommerce/categories"
    import Banner from "../widgets/Banner.svelte"

    let navigationElements: NavigationElement[] = [],
        navOpen = false,
        subNavOpen: { [key: number]: boolean } = {},
        windowWidth: number

    function elementsToCache(elements: NavigationElement[]) {
        elements.forEach((el) => {
            if (!el.external) {
                if (!$navigationCache[el.page]) $navigationCache[el.page] = el
                if (el.elements?.length > 0) elementsToCache(el.elements)
            }
        })
    }

    getDBEntry("navigation", {
        tree: 0,
    }).then((nav) => {
        getCategories().then((categories) => {
            nav.elements = nav.elements.map((el) => {
                el.type = "content"
                return el
            })
            const bigCommerceNav = mapBigcommerceCategoriesToNavigation(categories)
            $categories = categories
            navigationElements.push(...bigCommerceNav, ...nav.elements)
            navigationElements = navigationElements

            elementsToCache([...nav.elements, ...bigCommerceNav])
        })
    })

    $: if (!navOpen) subNavOpen = {}
    $: if ($location) navOpen = false

    let scrolled: boolean = false,
        isHomepage: boolean = false,
        bannerVisible = false
    $: isHomepage = !$location.path || $location.path === "/"

    function checkScroll() {
        scrolled = window.scrollY >= 100
    }

    onMount(() => {
        if (typeof window !== "undefined") {
            checkScroll()
            window.addEventListener("scroll", checkScroll)
            return () => {
                window.removeEventListener("scroll", checkScroll)
            }
        }
    })
    $: {
        if (typeof window !== "undefined" && $location) {
            checkScroll()
        }
    }
</script>

<svelte:window bind:innerWidth="{windowWidth}" />

<Banner bind:isVisible="{bannerVisible}" />
<header
    class="headercontainer"
    id="{'header-container'}"
    class:scrolled="{scrolled}"
    class:homepage="{isHomepage}"
    role="dialog"
    on:focus
>
    <div class="padding">
        {#if navigationElements.length}
            {#key [bannerVisible, scrolled]}
                <DesktopHeader
                    elements="{navigationElements}"
                    bannerVisible="{bannerVisible}"
                    scrolled="{isHomepage ? scrolled : false}"
                />
            {/key}
        {/if}
    </div>
</header>

<style lang="less">
    @import "../../assets/css/variables.less";

    @desktop: ~"only screen and (min-width: 1440px)";

    .headercontainer {
        display: flex;
        flex-direction: column;
        position: sticky;
        z-index: 5500;
        top: 0px;
        justify-content: space-between;
        background-color: #0d0c0c;
        &.homepage {
            background-color: transparent;
        }
        align-items: center;
        width: 100%;
        .padding {
            width: 100%;
            padding: 0px var(--horizontal-default-margin);
            height: 100%;
            display: flex;
            align-items: flex-end;
            justify-content: center;
        }

        &.scrolled&.homepage {
            box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.2);
            background-color: var(--neutral-white);
        }
    }
</style>
